/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'Dashboard';

const classes = {
  content: `${PREFIX}-content`,
  borderBox: `${PREFIX}-borderBox`,
};

const Root = styled(Box)(({theme}) => ({
  width: '100%',
  position: 'relative',

  [`& .${classes.content}`]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2, 0, 2),
    position: 'relative',
    zIndex: 1,
  },

  [`& .${classes.borderBox}`]: {
    width: '100%',
    height: 'calc(100% - 65px)',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
    borderRadius: '16px',
    border: '1px solid #4a4b4f',
  },
}));

export {Root as DashboardRoot, classes as dashboardClasses};
